import React, { useEffect, useState } from "react";
import {
    Box, Button, Flex, Text, Icon, Badge, useColorModeValue,
} from "@chakra-ui/react";
import { CheckCircle2, Unlink, Link2 } from "lucide-react";
import { FaGoogleDrive } from "react-icons/fa";
import Card from "components/card/Card.js";
import { QuickAlert } from "theme/components/alerts";
import { userController } from "lib/user";

function AppSettingsIntegrations() {
    const { setAlert, showAlert } = QuickAlert();
    const { getSingleRecord, saveRecord } = userController();
    const headerBorderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");

    const [driveStatus, setDriveStatus]     = useState(null);
    const [driveEmail, setDriveEmail]       = useState(null);
    const [disconnecting, setDisconnecting] = useState(false);

    useEffect(() => {
        loadDriveStatus();
    }, []);

    // Check if we were redirected back after OAuth
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get("drive") === "connected") {
            setAlert("success", "Google Drive collegato correttamente.");
            window.history.replaceState({}, "", window.location.pathname);
            loadDriveStatus();
        } else if (params.get("drive") === "error") {
            setAlert("error", { drive: ["Collegamento a Google Drive non riuscito. Riprova."] });
            window.history.replaceState({}, "", window.location.pathname);
        }
    }, []);

    const loadDriveStatus = () => {
        setDriveStatus(null);
        getSingleRecord("/user/app-settings/drive/status")
            .then((res) => {
                setDriveStatus(res.data.connected);
                setDriveEmail(res.data.email);
            })
            .catch(() => setDriveStatus(false));
    };

    const connectDrive = () => {
        window.location.href = process.env.REACT_APP_URL + "/drive/google/redirect";
    };

    const disconnectDrive = () => {
        setDisconnecting(true);
        saveRecord("/user/app-settings/drive/disconnect", {})
            .then((res) => {
                setAlert("success", res.data.message);
                setDriveStatus(false);
                setDriveEmail(null);
                setDisconnecting(false);
            })
            .catch((error) => {
                setAlert("error", error.response.data.errors);
                setDisconnecting(false);
            });
    };

    return (
        <Box>
            <Card mb="20px" p="0">
                <Flex justify="space-between" align="center" pt="20px" pb="16px" px="24px" borderBottom="1px solid" borderColor={headerBorderColor}>
                    <Text color="secondaryGray.900" fontSize="22px" fontWeight="700" lineHeight="100%">
                        Integrazioni
                    </Text>
                </Flex>
                <Box px="24px" pt="20px" pb="24px">
                {showAlert()}

                {/* Google Drive Row */}
                <Flex align="center" justify="space-between" flexWrap="wrap" gap="16px">
                    <Flex align="center" gap="14px">
                        <Flex
                            w="48px" h="48px" borderRadius="12px"
                            bg="oklch(97% .014 254.604)" align="center" justify="center" flexShrink={0}
                        >
                            <Icon as={FaGoogleDrive} boxSize="24px" color="oklch(48.8% .243 264.376)" />
                        </Flex>
                        <Box>
                            <Flex align="center" gap="8px" mb="2px">
                                <Text fontWeight="semibold" fontSize="md">Google Drive</Text>
                                {driveStatus === null && (
                                    <Badge colorScheme="gray" borderRadius="6px">Verifica in corso...</Badge>
                                )}
                                {driveStatus === true && (
                                    <Badge colorScheme="green" borderRadius="6px">
                                        <Flex align="center" gap="4px">
                                            <Icon as={CheckCircle2} boxSize="12px" />
                                            Collegato
                                        </Flex>
                                    </Badge>
                                )}
                                {driveStatus === false && (
                                    <Badge colorScheme="red" borderRadius="6px">Non collegato</Badge>
                                )}
                            </Flex>
                            <Text fontSize="xs" color="gray.500">
                                {driveStatus === true && driveEmail
                                    ? `Collegato come ${driveEmail}`
                                    : "Utilizzato per archiviare i documenti di identità degli ospiti."}
                            </Text>
                        </Box>
                    </Flex>

                    <Flex gap="10px">
                        {driveStatus === true ? (
                            <Button
                                variant="outline"
                                colorScheme="red"
                                size="sm"
                                leftIcon={<Unlink />}
                                isLoading={disconnecting}
                                onClick={disconnectDrive}
                            >
                                Scollega
                            </Button>
                        ) : (
                            <Button
                                variant="brand"
                                size="sm"
                                leftIcon={<Link2 />}
                                isDisabled={driveStatus === null}
                                onClick={connectDrive}
                            >
                                Collega Google Drive
                            </Button>
                        )}
                    </Flex>
                </Flex>
                </Box>
            </Card>
        </Box>
    );
}

export default AppSettingsIntegrations;
